<template>
  <Module
    :id="selectionData.conf.id"
    :isLoaded="true"
  >
    <template>
      <div class="postcard">
        <ModulePostcardMain
          :selectionData="selectionData.main"
        />

        <slot v-if="selectionData.main.mode === 1">
          <ModulePostcardMotive
            :selectionData="selectionData.motive"
          />

          <ModulePostcardMessage
            :selectionData="selectionData.message"
          />
        </slot>

        <ModulePostcardAddons
          v-if="$store.getters.isB2b && (selectionData.main.mode && selectionData.main.mode !== 4)"
          :selectionData="selectionData.addons"
        />

        <slot v-if="selectionData.main.mode && selectionData.message.mode">
          <hr>

          <p class="u-text-center u-text-dimmed">Ihre Angaben zur Grußkarte sind vollständig.</p>
          <p class="u-dp-flex u-justify-center"><Button type="button" appearance="secondary" @click="$parent.openModule('shipping')">zu den Lieferoptionen</Button></p>
        </slot>
      </div>
    </template>
  </Module>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Module from '@/components/Composer/Module';
import Button from '@/components/Common/Button';
import ModulePostcardMain from '@/components/Composer/ModulePostcardMain';
import ModulePostcardMotive from '@/components/Composer/ModulePostcardMotive';
import ModulePostcardMessage from '@/components/Composer/ModulePostcardMessage';
import ModulePostcardAddons from '@/components/Composer/ModulePostcardAddons';

export default {
  name: 'ModulePostcard',
  mixins: [logicMixin],
  props: ['selectionData'],
  components: {
    Button,
    Module,
    ModulePostcardMain,
    ModulePostcardMotive,
    ModulePostcardMessage,
    ModulePostcardAddons
  },
  data () {
    return {
    };
  },
  methods: {
  }
};

</script>

<style lang="scss" scoped>
/**
 * Postcard Module
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard's tab content
 * @since 2021-08-17
**/

$component: 'postcard';

.#{$component} {
  &__deck {
    position: relative;
    transform: scale(0.9);

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__icon-1 {
    transform: rotate(-10deg);
  }
  &__icon-2,
  &__icon-3 {
    position: absolute;
    top: 0;
    right: 0;
    box-shadow: 0 0 1px rgba($ink, 0.4);
    transform: rotate(10deg);
  }

  &__icon-2 {
    background-color: $aqua;
  }

  &__icon-3 {
    @include rfs(-0.4rem, left);
    background-color: $yellow;
    transform: rotate(6deg);
  }

  ::v-deep {
    .module-postcard-carousel {
      @include margin-left(- map-get($spacers, 4));
      @include margin-right(- map-get($spacers, 4));

      .glide {
        &__track {
          @include padding-left(map-get($spacers, 4));
          @include padding-right(map-get($spacers, 4));
        }

        &__slides {
          overflow: visible;
        }
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
